//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { directive } from 'vue-awesome-swiper';
export default {
  props: ['resources', 'content_type', 'product', 'thumb_type', 'ratio', 'slug'],
  computed: {
    swiper() {
      return this.$refs['swiper_' + this.content_type].$swiper;
    },
  },
  components: {
    descriptionItem: () => import('~/components/content/video/info/description.vue'),
    thumb: () => import('~/components/thumb'),
    VideoPreviewThumb: () => import('~/components/VideoPreviewThumb'),
    dateviews: () => import('~/components/date_views'),
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      read: {
        text: 'Lees meer',
        active: false,
      },
      swiperOptions: {
        autoplay: true,
        loop: false,
        effect: 'fade',
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true,
        },
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true, 
        },
        navigation: {
          nextEl: '.swiper-button-next',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  mounted() {
    this.$forceUpdate();
  },
};
